import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const is2FAPending = localStorage.getItem("2FA_PENDING") === "true";
  const token = localStorage.getItem("token");

  if (!token || is2FAPending) {
    return <Navigate to="/signin" state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
